import { render, staticRenderFns } from "./detailview.vue?vue&type=template&id=217a243a&scoped=true"
import script from "./detailview.vue?vue&type=script&lang=ts"
export * from "./detailview.vue?vue&type=script&lang=ts"
import style0 from "./detailview.vue?vue&type=style&index=0&id=217a243a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a243a",
  null
  
)

export default component.exports